export function registerOptionalTextAnnotationPopup(registerHandler, handler) {
  if (typeof registerHandler !== 'function') return undefined;

  registerHandler(handler);
  return () => registerHandler(null);
}
